module.exports = "<div class=\"gmodal-container\">\n\t<div class=\"gmodal-wrap gmodal-left\"></div>\n\t<div class=\"gmodal-wrap gmodal-content\" id=\"gmodalContent\"></div>\n\t<div class=\"gmodal-wrap gmodal-right\"></div>\n<div>"


//////////////////
// WEBPACK FOOTER
// ./src/template.html
// module id = 3
// module chunks = 0